import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ui-error',
  standalone: true,
  imports: [],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent {
  public readonly error = input('');
}
